import type { FC } from 'react'

import { Input, Select } from '@skytech/ui'
import { getLocaleTimezoneIsoDate, getMaxDate } from '@skytech/utils'
import { useQuery } from '@tanstack/react-query'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import terminationResources from '@/modules/subscriptions/termination/resources'

import queries from '../queries'

export const NewTerminationDetails: FC<{}> = () => {
  const translate = useTranslation()
  const { data: setup } = useQuery(queries.terminationSetup(), terminationResources.getSetup)

  const costObjectOptions = (setup?.costObjectList || []).map(co => ({
    value: co.id,
    label: `${co.departmentName ? `${co.departmentName} - ` : ''}${co.code}${
      co.name ? ` - ${co.name}` : ''
    }${co.employeeNo ? ` - ${co.employeeNo}` : ''}`,
  }))

  return (
    <div>
      <h3>
        <Translation id="Details" />
      </h3>
      <div className="-m-2 flex flex-wrap items-start">
        <div className="m-2 min-h-[7.25rem] min-w-[20rem] flex-1 rounded-lg bg-[#f8f8f8] p-4">
          <Field name="costObjectId">
            {({ field, form, meta }: FieldProps) => (
              <Select
                capitalizeLabel
                id="costObjectId"
                label={
                  <>
                    <Translation id="Employee" />*
                  </>
                }
                placeholder={translate('Select employee')}
                options={costObjectOptions}
                marginBottom={16}
                touched={meta.touched}
                error={meta.error}
                {...field}
                onChange={option => form.setFieldValue(field.name, option?.value)}
              />
            )}
          </Field>
        </div>
        <div className="m-2 min-h-[7.25rem] min-w-[20rem] flex-1 rounded-lg bg-[#f8f8f8] p-4">
          <Field name="terminationDate">
            {({ field, meta }: FieldProps) => (
              <Input
                capitalizeLabel
                isFullWidth
                id="terminationDate"
                type="date"
                ariaLabel={translate('Termination date')}
                label={
                  <>
                    <Translation id="Termination date" />*
                  </>
                }
                min={getLocaleTimezoneIsoDate(new Date())}
                max={getLocaleTimezoneIsoDate(getMaxDate(12))}
                marginBottom={16}
                touched={meta.touched}
                error={meta.error}
                {...field}
              />
            )}
          </Field>
        </div>
      </div>
    </div>
  )
}
